import qc from 'qc'
import { scripts } from '@ps/bridge/qc/scripts/index'

export interface GridViewScript {
  gridsConfig: any
}

/**
 * ps.gridView 网格快捷布局
 * @param node
 * @param addScriptIfScriptNotExist
 */
export const getScript = (
  node: qc.Node,
  addScriptIfScriptNotExist = true,
): GridViewScript | undefined => {
  const config: GridViewScript | undefined = node.getScript(
    scripts.gridView.name,
  )
  if (config) {
    return config
  }
  if (addScriptIfScriptNotExist) {
    return node.addScript(scripts.gridView.name) as GridViewScript
  }
  return config
}
